<ng-container *ngIf="modulePermitted; else moduleNotPermitted">
    <app-bx-notices
        [noticeRetrievalMethod]="noticeRetrievalMethod"
        [objectIds]="jobIds"
        [modules]="noticeModuleNames"
        (viewClick)="onViewNotice($event)">
    </app-bx-notices>
    <h6 class="bxt-table-title">{{ title }} ({{ page.totalElements }})</h6>

    <bx-table-header
        (createNew)="addJob()"
        [showCreateNew]="permissionService.isAvailable('jobs.maintain-jobs.create-new-job') && featureService.isAvailable('jobs_create')"
        [createNewEnabled]="!deletedView"
        (searchEvent)="setSearch($event)"
        [searchable]="true"
        [showSettingsActions]="true"
        [moreActions]="moreActions"
        (moreActionEvent)="resolveAction($event)"
        [moreActionsDisabled]="deletedView">
        <app-bx-dropdown-generic settings #dropdown [buttonLabel]="'Settings'" [placement]="'right'" [insideClick]="true">
            <div class="group-start">
                <app-bx-dropdown-options [groups]="settingsActions" [type]="'radio'" (select)="resolveSettingsAction($event)">
                </app-bx-dropdown-options>
            </div>

            <div class="group-end">
                <app-bx-dropdown-options
                    [groups]="simpleItems"
                    [type]="'simple'"
                    (select)="resolveSimpleItemsSettingsAction($event); dropdown.close()">
                </app-bx-dropdown-options>
            </div>
        </app-bx-dropdown-generic>
    </bx-table-header>

    <div class="col-xs-12 text-center empty-table" *ngIf="rows?.length === 0 && !isLoading">
        <h4
            *ngIf="
                !deletedView &&
                permissionService.isAvailable('jobs.maintain-jobs.create-new-job') &&
                featureService.isAvailable('jobs_create')
            "
            class="margin-top-30 margin-bottom-30">
            Get started, <a (click)="addJob()">create a new job</a>
        </h4>
        <h4 *ngIf="deletedView" class="margin-top-30 margin-bottom-30">You don't have any deleted jobs.</h4>
    </div>

    <div class="table-wrapper" #tableWrapper>
        <ngx-datatable
            [ngStyle]="{ height: tableHeight }"
            *ngIf="rows.length > 0"
            #jobsTable
            class="material bxt-table"
            [rowHeight]="40"
            [rows]="rows"
            [columnMode]="tableColumnMode"
            [headerHeight]="50"
            [loadingIndicator]="isLoading"
            [footerHeight]="50"
            [externalPaging]="true"
            [count]="page.totalElements"
            [offset]="page.pageNumber"
            [limit]="page.size"
            (page)="setPage($event)"
            [externalSorting]="true"
            (sort)="onSort($event)"
            [scrollbarV]="true"
            [scrollbarH]="layoutService.isMobile()"
            [virtualization]="false"
            [sorts]="[{ prop: sortField, dir: 'desc' }]"
            (resize)="onResize()">
            <!-- columns  -->
            <ngx-datatable-column
                name="Ref#"
                prop="number"
                [cellClass]="'show-pipe'"
                [headerClass]="'show-pipe'"
                [flexGrow]="4"
                [width]="jobsWidths.Number">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="ti-lock" *ngIf="row.isForeignOwned" title="Someone else owns this template."> {{ row.number }}</i>
                    <span *ngIf="!row.isForeignOwned">
                        <a
                            class="bxt-row-action"
                            *ngIf="permissionService.isAvailable('jobs.maintain-jobs.view-jobs') && !row.isDeleted; else disabledTag"
                            [routerLink]="['/jobs', 'list', row.iD_Job]"
                            >{{ row.number }}</a
                        >
                    </span>
                    <ng-template #disabledTag>{{ row.number }}</ng-template>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Description" prop="description" [flexGrow]="8" [width]="jobsWidths.Description">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.isForeignOwned" title="Someone else owns this template." [title]="row.description"
                        ><i class="ti-lock"> </i> {{ row.description }}</span
                    >
                    <span *ngIf="!row.isForeignOwned" [title]="row.description">
                        <a
                            *ngIf="permissionService.isAvailable('jobs.maintain-jobs.view-jobs') && !row.isDeleted; else disabledDesc"
                            class="bxt-row-action"
                            [routerLink]="['/jobs', 'list', row.iD_Job]"
                            >{{ row.description }}</a
                        >
                    </span>
                    <ng-template #disabledDesc
                        ><span [title]="row.description">{{ row.description }}</span></ng-template
                    >
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Type" prop="buildingType" [flexGrow]="5" [width]="jobsWidths.BuildingType">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span [textContent]="row.buildingType"></span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Progress"
                prop="progressPercent"
                [cellClass]="'full-width'"
                [flexGrow]="5"
                [width]="jobsWidths.ProgressPercent">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div title="Overall progress of this jobs tasks">
                        <label class="progressbar-label">{{ row.progressPercent }}%</label>
                        <progressbar [value]="row.progressPercent" class="progress-green"></progressbar>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Variance"
                prop="variancePercent"
                [cellClass]="'full-width'"
                [sortable]="false"
                [flexGrow]="5"
                [width]="jobsWidths.VariancePercent">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div title="Variance of actual compared to estimated">
                        <label class="progressbar-label">{{ row.variancePercent }}%</label>
                        <progressbar [value]="row.variancePercent" class="progress-green"></progressbar>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Invoiced"
                prop="invoicedPercent"
                [cellClass]="'full-width'"
                [sortable]="false"
                [flexGrow]="5"
                [width]="jobsWidths.InvoicedPercent">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div title="Percentage of amount invoiced to date">
                        <label class="progressbar-label">{{ row.invoicedPercent }}%</label>
                        <progressbar [value]="row.invoicedPercent" class="progress-blue"></progressbar>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Gross Profit"
                prop="grossProfit"
                [cellClass]="'full-width'"
                [sortable]="false"
                [flexGrow]="7"
                *ngIf="permissionService.isAvailable('jobs.jobs-access.grossprofit')"
                [width]="jobsWidths.GrossProfit">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div title="Gross profit">
                        <div class="progressbar-label">
                            <label class="progressbar-label-left" [title]="row.grossProfitPercent + '%'"
                                >{{ row.grossProfitPercent }}%</label
                            >
                            <label
                                class="progressbar-label-right"
                                [title]="row.grossProfit | bxCurrency"
                                [ngClass]="
                                    row.grossProfit < 0
                                        ? 'progressbar-label-right--alert'
                                        : row.GrossProfit > 0
                                          ? 'progressbar-label-right--green'
                                          : ''
                                ">
                                {{ row.grossProfit | bxCurrency: undefined : 'symbol' : '1.0-0' }}</label
                            >
                        </div>
                        <progressbar [value]="row.grossProfitPercent" class="progress-green"></progressbar>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Client" prop="clientName" [flexGrow]="7" [width]="jobsWidths.ClientName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        *ngIf="
                            row.iD_Customer &&
                                permissionService.isAvailable('customers.maintain-customers.view-customers') &&
                                !row.isDeleted;
                            else disabledClient
                        "
                        class="bxt-row-action"
                        [routerLink]="['/customers', 'list', row.iD_Customer]"
                        [title]="row.clientName">
                        {{ row.clientName }}</a
                    >
                    <ng-template #disabledClient
                        ><span [title]="row.clientName">{{ row.clientName }}</span></ng-template
                    >
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Date" prop="createdAt" [flexGrow]="6" [width]="jobsWidths.CreationDate">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.createdAt | date: 'mediumDate' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                *ngIf="deletedView"
                [sortable]="false"
                name="Deleted Date"
                prop="dateDeleted"
                [headerClass]="'disabled'"
                [flexGrow]="6">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.dateDeleted | date: 'mediumDate' }}
                </ng-template>
            </ngx-datatable-column>

            <!-- Call to action list-->
            <ngx-datatable-column
                [width]="120"
                [sortable]="false"
                [canAutoResize]="false"
                [draggable]="false"
                [resizeable]="false"
                [cellClass]="'right-align'"
                [headerClass]="'disabled'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.isDeleted">
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            (click)="copyJob(row)"
                            title="Create Copy"
                            *ngIf="featureService.isAvailable('jobs_copy')"
                            [disabled]="!permissionService.isAvailable('jobs.maintain-jobs.copy-job') || row.invoiceMethod === 2">
                            <i class="ti-files"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-default"
                            (click)="createEstimateFromJob(row)"
                            title="Create Estimate"
                            *ngIf="featureService.isAvailable('jobs_copy') && !estimateCreationViaLeadOnly"
                            [disabled]="!permissionService.isAvailable('estimates.maintain-estimates.create-estimate')">
                            <i class="icon-ic-estimates-s1"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            (click)="deleteJob($event, row)"
                            title="Delete"
                            *ngIf="featureService.isAvailable('jobs_delete')"
                            [disabled]="!permissionService.isAvailable('jobs.maintain-jobs.delete-job')">
                            <i class="ti-trash"></i>
                        </button>
                    </div>
                    <div *ngIf="row.isDeleted">
                        <button
                            type="button"
                            class="btn btn-sm btn-default"
                            (click)="recoveryJobs(row)"
                            title="Recovery"
                            *ngIf="permissionService.isAvailable('recycle-bin.recover-data.recycle-bin-access')">
                            <i class="ti-reload"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
                <ng-template
                    ngx-datatable-footer-template
                    let-rowCount="rowCount"
                    let-pageSize="pageSize"
                    let-selectedCount="selectedCount"
                    let-curPage="curPage"
                    let-offset="offset"
                    let-isVisible="isVisible">
                    <app-table-footer-paging *ngIf="rowCount > 10" [size]="page.size" (pageLimitChange)="pageLimit($event)">
                    </app-table-footer-paging>

                    <datatable-pager
                        [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'"
                        [page]="curPage"
                        [size]="pageSize"
                        [count]="rowCount"
                        [hidden]="!(rowCount / pageSize > 1)"
                        (change)="table.onFooterPage($event)">
                    </datatable-pager>
                </ng-template>
            </ngx-datatable-footer>
        </ngx-datatable>
    </div>

    <div class="row">
        <help-note-wrapper
            title="{{ 'helpNotes.jobs.list.title' | translate }}"
            class="col-sm-12"
            url="{{ 'helpNotes.jobs.list.url' | translate }}"
            footer="Read more in our FAQ’s"
            setting="NoteJobList"
            [expanded]="true"
            *ngIf="!deletedView"
            [videoUrl]="'helpNotes.jobs.list.video-url' | translate">
            {{ 'helpNotes.jobs.list.text' | translate }}
        </help-note-wrapper>
    </div>
</ng-container>
<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
